import React, { Fragment } from "react";

const About = () => {
  return (
    <Fragment>
      <h1>
        <u>About This App</u>
      </h1>
      <p>App to search Github users</p>
      <p>Done by Usama Gierdien. Student at Lifechoices Coding Bootcamp.</p>
    </Fragment>
  );
};

export default About;
